"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FixedAmountDiscountShippingPromotion = void 0;
const typings_1 = require("../../typings");
const utils_1 = require("../../utils");
const base_1 = require("../base");
class FixedAmountDiscountShippingPromotion extends base_1.BasePromotion {
    constructor(props) {
        super(props);
        this.props = props;
    }
    /**
     * Get award from total price (including additional discount) or award from sum of product skus flag
     * @returns {boolean}
     */
    get isAwardFromTotalPrice() {
        return this.props.settings.awardTotalPrice || false;
    }
    /**
     * Apply fixed amount discount shipping for whole cart
     * e.g. original shipping price is 50B and get discount 30B. so final shipping price is 20B
     * @param cart
     * @returns {Cart}
     */
    applyFixedAmountDiscountForAnyProductPromotion(cart) {
        if (!cart.productSKUs.length || !this.isMatchedSelectedShippingMethod(cart)) {
            return cart;
        }
        const discount = this.getPromotionDiscount();
        if (discount === undefined) {
            return cart;
        }
        const newCart = Object.assign({}, cart);
        // Total shipping discount cannot be more than current total shipping price
        const totalShippingPrice = cart.shippingPrice - cart.totalShippingDiscount;
        const totalShippingDiscount = totalShippingPrice > discount ? discount : totalShippingPrice;
        // Add applied promotion to every product skus
        const productSKUsWithAppliedPromotion = this.addAppliedPromotionToProductSKUs(newCart.productSKUs, {
            totalDiscount: totalShippingDiscount,
        });
        return this.composeNewCartWithAppliedPromotion(Object.assign(Object.assign({}, newCart), { productSKUs: productSKUsWithAppliedPromotion }), { totalDiscount: totalShippingDiscount });
    }
    /**
     * Apply fixed amount discount shipping for selected product in bundle
     * e.g. 3 piece of mix selected product for discount shipping 30B
     * @param cart
     * @returns {Cart}
     */
    applyFixedAmountDiscountForSelectedProductInBundlePromotion(cart) {
        const isBundled = this.bundleSetting;
        if (!isBundled) {
            throw new Error('Could not apply fixed amount discount shipping promotion for X piece of selected product in bundle that is not mark as bundled');
        }
        if (!cart.productSKUs.length || !this.isMatchedSelectedShippingMethod(cart)) {
            return cart;
        }
        const discount = this.getDiscountByTarget((0, utils_1.getTotalAmountOfSelectedProducts)(cart.productSKUs, this.selectedProductIds));
        if (discount === undefined) {
            return cart;
        }
        const newCart = Object.assign({}, cart);
        let productSKUsWithAppliedPromotion = [...newCart.productSKUs];
        let totalShippingDiscount = 0;
        // Total shipping discount cannot be more than current total shipping price
        const totalShippingPrice = cart.shippingPrice - cart.totalShippingDiscount;
        totalShippingDiscount = totalShippingPrice > discount ? discount : totalShippingPrice;
        // Add applied promotion to every selected product skus
        productSKUsWithAppliedPromotion = this.addAppliedPromotionToProductSKUs(newCart.productSKUs, {
            totalDiscount: totalShippingDiscount,
        });
        return this.composeNewCartWithAppliedPromotion(Object.assign(Object.assign({}, newCart), { productSKUs: productSKUsWithAppliedPromotion }), { totalDiscount: totalShippingDiscount });
    }
    applyFixedAmountDiscountForInTotalOfAnyProductPromotion(cart) {
        if (!cart.productSKUs.length || !this.isMatchedSelectedShippingMethod(cart)) {
            return cart;
        }
        /**
         * Award with total price which include additional discount to compare
         * against with price threshold
         * e.g.
         * 290 with threshold of 500B
         *
         * 500 (threshold) > 290 (total with additional discount)
         */
        const discount = this.isAwardFromTotalPrice
            ? this.getDiscountByTarget(cart.totalPrice)
            : this.getDiscountByTarget((0, utils_1.getTotalPrice)(cart.productSKUs));
        if (discount === undefined) {
            return cart;
        }
        // Total shipping discount cannot be more than current total shipping price
        const totalShippingPrice = cart.shippingPrice - cart.totalShippingDiscount;
        const totalShippingDiscount = totalShippingPrice > discount ? discount : totalShippingPrice;
        // Add applied promotion to every product skus
        const productSKUsWithAppliedPromotion = this.addAppliedPromotionToProductSKUs(cart.productSKUs, {
            totalDiscount: totalShippingDiscount,
        });
        return this.composeNewCartWithAppliedPromotion(Object.assign(Object.assign({}, cart), { productSKUs: productSKUsWithAppliedPromotion }), { totalDiscount: totalShippingDiscount });
    }
    applyFixedAmountDiscountForInTotalOfSelectedProductPromotion(cart) {
        if (!cart.productSKUs.length || !this.isMatchedSelectedShippingMethod(cart)) {
            return cart;
        }
        /**
         * Award with total price which include additional discount to compare
         * against with price threshold
         * e.g.
         * 290 with threshold of 500B
         *
         * 500 (threshold) > 290 (total with additional discount)
         */
        const discount = this.isAwardFromTotalPrice
            ? this.getDiscountByTarget((0, utils_1.getTotalPriceIncludingDiscountOfSelectedProducts)(cart.productSKUs, this.selectedProductIds))
            : this.getDiscountByTarget((0, utils_1.getTotalPriceOfSelectedProducts)(cart.productSKUs, this.selectedProductIds));
        if (discount === undefined) {
            return cart;
        }
        // Total shipping discount cannot be more than current total shipping price
        const totalShippingPrice = cart.shippingPrice - cart.totalShippingDiscount;
        const totalShippingDiscount = totalShippingPrice > discount ? discount : totalShippingPrice;
        // Add applied promotion to every product skus
        const productSKUsWithAppliedPromotion = this.addAppliedPromotionToProductSKUs(cart.productSKUs, {
            totalDiscount: totalShippingDiscount,
        });
        return this.composeNewCartWithAppliedPromotion(Object.assign(Object.assign({}, cart), { productSKUs: productSKUsWithAppliedPromotion }), { totalDiscount: totalShippingDiscount });
    }
    /**
     * Apply promotion
     * @param cart
     * @returns {Cart}
     */
    applyPromotion(cart) {
        switch (this.settingCondition) {
            case typings_1.PromotionCondition.BUY_ANY_PRODUCT:
                return this.applyFixedAmountDiscountForAnyProductPromotion(cart);
            case typings_1.PromotionCondition.BUY_X_PIECE_OF_SELECTED_PRODUCT_IN_BUNDLE:
                return this.applyFixedAmountDiscountForSelectedProductInBundlePromotion(cart);
            case typings_1.PromotionCondition.BUY_X_PRICE_IN_TOTAL_OF_ANY_PRODUCT:
                return this.applyFixedAmountDiscountForInTotalOfAnyProductPromotion(cart);
            case typings_1.PromotionCondition.BUY_X_PRICE_IN_TOTAL_OF_SELECTED_PRODUCT_IN_BUNDLE:
                return this.applyFixedAmountDiscountForInTotalOfSelectedProductPromotion(cart);
            default:
                return cart;
        }
    }
}
exports.FixedAmountDiscountShippingPromotion = FixedAmountDiscountShippingPromotion;
//# sourceMappingURL=fixed-amount.js.map